<template>
  <div class="page-allergic-rhinitis">
    <!-- Begin head block -->
    <section class="head-block">
      <div class="container">
        <div class="head-block__bg">
          <img src="~@/assets/img/allergic-rhinitis/banner-bg.jpg" alt="" />
        </div>
        <div class="row">
          <div class="col-x-lg-8 col-lg-8 col-md-8 col-xs-12">
            <h1
              class="head-block__title"
              v-html="$t('allergicRhinitis.title')"
            ></h1>
            <p
              class="head-block__text"
              v-html="$t('allergicRhinitis.text')"
            ></p>
            <div class="block-list">
              <div
                class="block-list__title"
                v-html="$t('allergicRhinitis.blockList.title')"
              ></div>
              <div class="block-list__row">
                <div
                  class="block-list__col"
                  v-for="(item, key) in $t('allergicRhinitis.blockList.items')"
                  :key="key"
                >
                  <div class="block-list__item">
                    <div class="block-list__item-number">{{ key + 1 }}</div>
                    <div class="block-list__item-text" v-html="item.text"></div>
                  </div>
                </div>
              </div>
              <div class="block-list__text">
                <p v-html="$t('allergicRhinitis.blockList.text_1')"></p>
                <p v-html="$t('allergicRhinitis.blockList.text_2')"></p>
              </div>
            </div>
          </div>
        </div>
        <div class="icons-list">
          <div
            class="icons-list__title"
            v-html="$t('allergicRhinitis.iconsList.title')"
          ></div>
          <div class="icons-list__row">
            <div
              class="icons-list__col"
              v-for="(item, key) in $t('allergicRhinitis.iconsList.items')"
              :key="key"
            >
              <div
                :class="`icons-list__item icons-list__item--${key + 1}`"
                v-html="item.title"
              ></div>
            </div>
          </div>
          <router-link
            @click.native="rinit2MainBtn()"
            :to="$t('allergicRhinitis.iconsList.button.link')"
            class="icons-list__btn"
          >
            {{ $t("allergicRhinitis.iconsList.button.title") }}
          </router-link>
        </div>
      </div>
    </section>
    <!-- // -->
    <!-- Begin bibliography -->
    <section class="bibliography">
      <div class="container">
        <div class="bibliography__info">
          <p v-html="$t('bibliography.info_1')"></p>
        </div>
        <div class="bibliography__list">
          <h3
            class="bibliography__list-title"
            v-html="$t('bibliography.bibliographyTitle')"
          ></h3>
          <div
            class="bibliography__list-item"
            v-for="(item, key) in $t('allergicRhinitis.bibliography.list')"
            :key="key"
          >
            <div class="bibliography__list-number">{{ key + 1 }}.</div>
            <div class="bibliography__list-text" v-html="item"></div>
          </div>
        </div>
      </div>
    </section>
    <!-- // -->
  </div>
</template>

<script>
export default {
  name: "allergicRhinitis",
  metaInfo() {
    if (this.$i18n.locale === "ua") {
      return {
        title: "Називін та алергічний риніт 🤧 Симптоми і профілактика",
        meta: [
          {
            name: "description",
            content:
              "Алергічний риніт - нетипова реакція імунної системи на чужорідні речовини 🦠 ( пилок, шерсть, продукти). Профілактика: 🦠🚫 💧🧹 🥗 😴 🚭"
          },
          {
            property: "og:description",
            content: "Називін та алергічний риніт 🤧 Симптоми і профілактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    } else if (this.$i18n.locale === "ru") {
      return {
        title: "Називин и аллергический ринит 🤧 Симптомы и профилактика",
        meta: [
          {
            name: "description",
            content:
              "Аллергический ринит - нетипичная реакция иммунной системы на чужеродные вещества 🦠 (пыльца, шерсть, продукты). Профилактика: 🦠🚫 💧🧹 🥗 😴 🚭"
          },
          {
            property: "og:description",
            content: "Називин и аллергический ринит 🤧 Симптомы и профилактика"
          },
          {
            property: "og:image",
            content: "/img/global/packshot.jpg"
          }
        ]
      };
    }
  },
  methods: {
    insertAfter(newNode, existingNode) {
      existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
    },
    responsive() {
      if (window.innerWidth <= 991) {
        var bannerImage = document.querySelector(".head-block__bg");
        var bannerTitle = document.querySelector(".head-block__title");
        this.insertAfter(bannerImage, bannerTitle);
      }
    },
    rinit2MainBtn() {
      // eslint-disable-next-line no-undef
      gtag("event", "click", { event_category: "rinit_2_main_btn" });
    }
  },
  mounted() {
    this.responsive();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto"
    });
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/views/_allergic-rhinitis";
</style>
